import type { PatientInfo, ReportSectionData } from './types';

export const PATIENT_INFO: PatientInfo = {
  name: "Ruzhdi Shera Ali",
  age: "28 years",
  gender: "Male",
  patientId: "P789-0123",
  accessionNumber: "A456-7890",
  referredBy: "OP",
  receptionDate: "October 31, 2024, 8:20 PM",
  resultDate: "October 31, 2024, 10:09 PM"
};

export const LAB_REPORT_DATA: ReportSectionData[] = [
  {
    title: "Biochemistry",
    results: [
      { name: "S. Cholestrol", value: 181.7, unit: "mg/dl", normalRange: "Up to 200" },
      { name: "S. Triglyceride", value: 312.50, unit: "mg/dl", normalRange: "Up to 200" },
      { name: "AST", value: 13.1, unit: "U/L", normalRange: "8-33" },
      { name: "Total Serum Bilirubin (TSB)", value: 0.247, unit: "mg/dl", normalRange: "Adult and Children: <1.2" },
      { name: "Blood Urea", value: 17.81, unit: "mg/dl", normalRange: "15-50" },
      { name: "Blood sugar ( Random )", value: 86.75, unit: "mg/dl", normalRange: "Random up to 140" },
    ]
  },
  {
    title: "Bone Markers Test",
    results: [
      { name: "Vitamin D3", value: 30.54, unit: "ng/ml", normalRange: "Deficiency: <10, Mild to moderate: 10-29, Sufficient: 30-70" },
    ]
  },
  {
    title: "General Urine Examination (GUE)",
    results: [
      { name: "Color", value: "Yellow", unit: "-", normalRange: "-" },
      { name: "Appearance", value: "Clear", unit: "-", normalRange: "-" },
      { name: "Reaction", value: "Acidic", unit: "-", normalRange: "-" },
      { name: "PH", value: 6, unit: "-", normalRange: "4.5-7.5" },
      { name: "Specific gravity", value: 1015, unit: "-", normalRange: "-" },
      { name: "Glucose", value: "NIL", unit: "-", normalRange: "-" },
      { name: "Ketone", value: "NIL", unit: "-", normalRange: "-" },
      { name: "Blood", value: "NIL", unit: "-", normalRange: "-" },
      { name: "Leukocyte", value: "NIL", unit: "-", normalRange: "-" },
      { name: "Urobilinogen", value: "Nil", unit: "-", normalRange: "-" },
      { name: "Bilirubin", value: "Nil", unit: "-", normalRange: "-" },
      { name: "Albumin(Protien)", value: "Nil", unit: "-", normalRange: "-" },
      { name: "Nitrite", value: "Nil", unit: "-", normalRange: "-" },
      { name: "Rbc Cells", value: "0-1", unit: "HPF", normalRange: "-" },
      { name: "Pus cells", value: "0-1", unit: "HPF", normalRange: "-" },
      { name: "Epithelial cells", value: "Nil", unit: "LPF", normalRange: "-" },
      { name: "Crystals", value: "Am. Ureat(Few)", unit: "-", normalRange: "-" },
      { name: "Cast", value: "Nil", unit: "-", normalRange: "-" },
      { name: "Bacteria", value: "NIL", unit: "-", normalRange: "-" },
      { name: "Mucus", value: "NIL", unit: "-", normalRange: "-" },
    ]
  },
  {
    title: "Hematology",
    results: [
      { name: "Complete Blood Count(CBC)", value: "Attached", unit: "-", normalRange: "-" },
    ]
  },
  {
    title: "Hormone",
    results: [
      { name: "Thyroid Stimulation Hormone (TSH)", value: 1.39, unit: "ulu/ml", normalRange: "0.270-4.20" },
    ]
  }
];